"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_FINANCIAL_ADJUSTMENT_PERMISSIONS = exports.FinancialAdjustmentPermissions = void 0;
/**
 * Permission catalog for the Financial Adjustment Platform (Sprint C,
 * Part 1). Per-action, matching every sibling catalog's own convention
 * — not one broad "adjustment" permission.
 */
exports.FinancialAdjustmentPermissions = {
    FINANCIAL_ADJUSTMENT_CREATE: 'financial:adjustment:create',
    FINANCIAL_ADJUSTMENT_READ: 'financial:adjustment:read',
    FINANCIAL_ADJUSTMENT_SUBMIT: 'financial:adjustment:submit',
    FINANCIAL_ADJUSTMENT_APPROVE: 'financial:adjustment:approve',
    FINANCIAL_ADJUSTMENT_CANCEL: 'financial:adjustment:cancel',
    /** Read-only — matches the PHARMACY_BILLING_AUDIT precedent. */
    FINANCIAL_ADJUSTMENT_AUDIT: 'financial:adjustment:audit',
};
exports.ALL_FINANCIAL_ADJUSTMENT_PERMISSIONS = Object.values(exports.FinancialAdjustmentPermissions);
//# sourceMappingURL=financial-adjustment.permissions.js.map